'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _materialIconsReact = require('material-icons-react');

var _materialIconsReact2 = _interopRequireDefault(_materialIconsReact);

var _grid = require('@rebass/grid');

var _Button = require('../Button');

var _Button2 = _interopRequireDefault(_Button);

var _theme = require('../../theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MaterialIconWrapper = function MaterialIconWrapper(props) {
  return _react2.default.createElement(
    'div',
    { className: props.className },
    _react2.default.createElement(_materialIconsReact2.default, props)
  );
};
MaterialIconWrapper.propTypes = { className: _propTypes2.default.string.isRequired };

var BannerContainer = _styledComponents2.default.div.withConfig({
  displayName: 'Banner__BannerContainer',
  componentId: 'sc-8aayce-0'
})(['width:100%;background-color:', ';'], function (props) {
  return props.variant === 'error' ? _theme.colors.errorTint : props.backgroundColor;
});

var BannerIcon = (0, _styledComponents2.default)(MaterialIconWrapper).withConfig({
  displayName: 'Banner__BannerIcon',
  componentId: 'sc-8aayce-1'
})(['display:flex;margin-right:14px;']);

var BannerMessage = _styledComponents2.default.div.withConfig({
  displayName: 'Banner__BannerMessage',
  componentId: 'sc-8aayce-2'
})(['&:first-child{padding-left:8px;}']);

var BannerHeading = _styledComponents2.default.div.withConfig({
  displayName: 'Banner__BannerHeading',
  componentId: 'sc-8aayce-3'
})(['color:', ' !important;font-size:16px;line-height:24px;'], function (props) {
  return props.color;
});

var BannerSubText = _styledComponents2.default.p.withConfig({
  displayName: 'Banner__BannerSubText',
  componentId: 'sc-8aayce-4'
})(['color:', ';font-size:16px;'], _theme.colors.black54);

var BannerList = _styledComponents2.default.ul.withConfig({
  displayName: 'Banner__BannerList',
  componentId: 'sc-8aayce-5'
})(['color:', ';font-size:16px;list-style:disc;padding:0 0 4px 17px;margin:0;'], _theme.colors.black54);

var BannerItem = _styledComponents2.default.li.withConfig({
  displayName: 'Banner__BannerItem',
  componentId: 'sc-8aayce-6'
})(['margin:6px 0 0;']);

var BannerButton = (0, _styledComponents2.default)(_Button2.default).withConfig({
  displayName: 'Banner__BannerButton',
  componentId: 'sc-8aayce-7'
})(['margin-left:8px;']);

var Banner = function Banner(props) {
  return _react2.default.createElement(
    BannerContainer,
    _extends({}, props, { className: 'banner' }),
    _react2.default.createElement(
      _grid.Box,
      { p: 16 },
      _react2.default.createElement(
        _grid.Flex,
        {
          alignItems: 'center',
          justifyContent: 'space-between'
        },
        _react2.default.createElement(
          _grid.Box,
          null,
          _react2.default.createElement(
            _grid.Flex,
            null,
            (props.variant === 'error' || props.icon) && _react2.default.createElement(
              _grid.Box,
              null,
              _react2.default.createElement(BannerIcon, {
                className: 'banner-' + props.variant,
                icon: props.variant === 'error' ? 'error' : props.icon,
                color: props.variant === 'error' ? _theme.colors.errorRed : props.iconColor
              })
            ),
            _react2.default.createElement(
              BannerMessage,
              null,
              _react2.default.createElement(
                BannerHeading,
                {
                  className: 'banner__heading',
                  color: props.variant === 'error' ? _theme.colors.errorRed : props.color
                },
                props.message.heading
              ),
              props.message.subText && _react2.default.createElement(
                BannerSubText,
                null,
                props.message.subText
              ),
              props.message.list && _react2.default.createElement(
                BannerList,
                null,
                props.message.list.map(function (item, index) {
                  return _react2.default.createElement(
                    BannerItem,
                    { key: 'banner-item-' + (index + 1) },
                    item
                  );
                })
              )
            )
          )
        ),
        props.onHandleClick && _react2.default.createElement(
          _grid.Box,
          null,
          _react2.default.createElement(
            BannerButton,
            {
              variant: 'link',
              buttonVariant: { color: _theme.colors.black54 },
              onClick: props.onHandleClick
            },
            props.buttonText
          )
        )
      )
    )
  );
};

Banner.propTypes = {
  buttonText: _propTypes2.default.string,
  color: _propTypes2.default.string,
  icon: _propTypes2.default.string,
  iconColor: _propTypes2.default.string,
  message: _propTypes2.default.shape({
    heading: _propTypes2.default.string,
    subText: _propTypes2.default.string,
    list: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array])
  }),
  onHandleClick: _propTypes2.default.func,
  variant: _propTypes2.default.string
};

Banner.defaultProps = {
  backgroundColor: _theme.colors.black10,
  buttonText: 'Dismiss',
  color: _theme.colors.black87,
  icon: null,
  onHandleClick: null,
  iconColor: _theme.colors.black38,
  message: null,
  variant: 'default'
};

exports.default = Banner;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-dev/thread/lib/components/Banner/index.js
// module id = 1126
// module chunks = 29